import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { buttonReset, focusRing } from '../../../../shared/theme/focusStyles';

const DATE_MODES = [
  { value: 'single', label: 'Single date' },
  { value: 'range', label: 'Date range' },
];

const ToggleContainer = styled('div')`
  display: inline-flex;
  padding: 2px;
  border: 1px solid ${({ theme }) => theme.colors.borderMedium};
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.surface};
`;

const ToggleButton = styled('button')`
  ${buttonReset}
  padding: 4px 10px;
  border-radius: 4px;
  background: ${({ active, theme }) => (active ? theme.colors.buttonPrimaryBg : 'transparent')};
  font-family: 'Nunito Sans';
  font-size: 13px;
  font-weight: 600;
  color: ${({ active, theme }) => (active ? theme.colors.white : theme.colors.text)};
  cursor: pointer;
  transition: background 0.2s ease;
  ${focusRing}
`;

const CopyDateModeToggle = ({
  ariaLabel, idPrefix, panelId, mode, onSelect, onEnterSelect,
}) => {
  const handleClick = (e) => {
    onSelect(e.currentTarget.value);
  };

  /* preventDefault suppresses the native Enter-to-click so the mode isn't set
     twice; Space still selects via onClick without moving focus. */
  const handleKeyDown = (e) => {
    if (e.key !== 'Enter') {
      return;
    }
    e.preventDefault();
    onEnterSelect(e.currentTarget.value, panelId);
  };

  return (
    <ToggleContainer aria-label={ariaLabel} role='tablist'>
      {DATE_MODES.map((option) => (
        <ToggleButton
          active={mode === option.value}
          aria-controls={panelId}
          aria-selected={mode === option.value}
          id={`${idPrefix}-${option.value}`}
          key={option.value}
          onClick={handleClick}
          onKeyDown={handleKeyDown}
          role='tab'
          type='button'
          value={option.value}
        >
          {option.label}
        </ToggleButton>
      ))}
    </ToggleContainer>
  );
};

CopyDateModeToggle.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  idPrefix: PropTypes.string.isRequired,
  panelId: PropTypes.string.isRequired,
  mode: PropTypes.oneOf(['single', 'range']).isRequired,
  onSelect: PropTypes.func.isRequired,
  onEnterSelect: PropTypes.func.isRequired,
};

export default CopyDateModeToggle;
